/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from "react"; // React Stuff
import withRouter from "../WithRouter";
import { Navigate, useNavigate, Link } from "react-router-dom";
//Packages
import axios from "axios";
import { Container, Col, Row, Button } from "react-bootstrap";
import { isAuthenticated } from "./services/auth"; //import auth
//TimeRendering
import Moment from "react-moment";
// Common
import FadeIn from "../common/FadeIn";
import StatusBlock from "../common/StatusBlock";

const CustomerView = (props) => {
  const [customerData, setCustomerData] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState("");
  // Handle Clicks, Submits, Errors
  const [submitClicked, setSubmitClicked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [updateKey, setUpdateKey] = useState(0);
  // Extract the customer ID
  const navigate = useNavigate();
  const customerid = props.params._id;
  const prevCustomerid = useRef(); //Reference the previous customer ID to ensure new get request if it changes.
  const prevUpdateKey = useRef();
  // Get the customer data and set it
  useEffect(async () => {
    prevCustomerid.current = customerid; // Assign Refs Value to current load
    prevUpdateKey.current = updateKey;
    // Get the Class Data
    const customerDataRequest = await axios.get(`/api/admin/manage/customers/${customerid}`, {
      withCredentials: true,
    });
    setParticipants(customerDataRequest.data.Participants);
    return setCustomerData(customerDataRequest.data);
  }, [customerid, updateKey]); // Run useEffect when the customer changes to get new customer data.

  //Fetch new data if a subcomponent calls for it.
  const fetchNewData = async () => {
    // Get the Class Data
    const customerDataRequest = await axios.get(`/api/admin/manage/customers/${customerid}`, {
      withCredentials: true,
    });
    return setCustomerData(customerDataRequest.data);
  };

  const deleteCustomer = async (e) => {
    e.preventDefault();
    const deleteRequest = await axios.delete(`/api/admin/manage/customers/${customerid}`, {
      withCredentials: true,
    });
    if (deleteRequest.status === 200) {
      setSubmitClicked(false);
      return navigate("/admin/customer-list/", { replace: true });
    } else {
      setSubmitClicked(false);
      return setErrorMessage("There was a problem with your request.");
    }
  };

  // Dismiss Message
  const dismissMessages = () => {
    setSuccessMessage("");
    return setErrorMessage("");
  };

  return (
    <div className='CustomerView'>
      <FadeIn delay={250} duration={450}>
        {isAuthenticated() ? (
          <Container>
            <Row className='text-center mt-3'>
              <Col sm='12'>
                <h1>Customer Info</h1>
              </Col>
            </Row>
            <Row className='align-items-center'>
              <Col className='text-center' sm='12' lg='8'>
                <div className='shadow mt-4 p-3 border'>
                  <h3>{`${customerData.First_Name} ${customerData.Last_Name}`}</h3>
                  <h5>Stripe Customer ID</h5>
                  <span>
                    <a
                      target='_blank'
                      rel='noopener noreferrer'
                      href={`https://dashboard.stripe.com/customers/${customerData.stripe_customer_id}`}
                    >
                      {customerData.stripe_customer_id}
                    </a>
                  </span>
                  <hr />
                  <h5>Address</h5>
                  {`${customerData.Street_Address}, ${customerData.City} ${customerData.Postcode}`}
                  <hr />
                  <h5>Tel</h5>
                  <a href={`tel:${customerData.Contact_Number}`}>{customerData.Contact_Number}</a>
                  <hr />
                  <h5>Email</h5>
                  <a href={`mailto:${customerData.email}`}>{customerData.email}</a>
                  <hr />
                  <h5>Marketing</h5>
                  Heard about: {customerData.heardAbout} | Consent: {customerData.marketingConsent}
                </div>
              </Col>
              {participants.length > 0 ? (
                <Col className='text-center mt-4 mt-lg-0' sm='12' lg='4'>
                  <div className='shadow mt-4 p-3 border'>
                    <h1>Participants</h1>
                    <p>Click to expand</p>
                    {participants.map((participant) => (
                      <Button
                        key={participant._id}
                        className='w-100 mt-2 mb-2'
                        onClick={(e) => setSelectedParticipant(participant._id, e)}
                      >
                        {`${participant.First_Name} ${participant.Last_Name}`}
                      </Button>
                    ))}
                  </div>
                </Col>
              ) : (
                <Col className='text-center' sm='12' lg='4'>
                  <div className='shadow mt-4 p-3 border'>
                    <h1>Delete Customer</h1>
                    <p>This customer has no participants, so you can delete it.</p>
                    <Button
                      variant='primary'
                      className='w-100 mt-2 mb-2'
                      onClick={(e) => deleteCustomer(e)}
                      disabled={submitClicked}
                    >
                      Delete
                    </Button>
                  </div>
                </Col>
              )}
            </Row>
            <Row>
              <Col sm='12'>
                <div>
                  <StatusBlock
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    dismissMessages={dismissMessages}
                  />
                </div>
              </Col>
            </Row>
            {selectedParticipant !== "" && (
              <ParticipantBlock
                fetchNewData={fetchNewData}
                setErrorMessage={setErrorMessage}
                setSuccessMessage={setSuccessMessage}
                setSubmitClicked={setSubmitClicked}
                submitClicked={submitClicked}
                selectedParticipant={selectedParticipant}
                setSelectedParticipant={setSelectedParticipant}
                participants={participants}
                setUpdateKey={setUpdateKey}
                updateKey={updateKey}
              />
            )}
          </Container>
        ) : (
          <Navigate to='/admin/' />
        )}
      </FadeIn>
    </div>
  );
};

const ParticipantBlock = (props) => {
  // Extract the data from the selected Participant
  const selectedParticipant = props.participants.find((x) => {
    return x._id === props.selectedParticipant;
  });

  const currentKey = props.updateKey;

  const deleteParticipant = async (e) => {
    e.preventDefault();
    const deleteRequest = await axios.delete(
      `/api/admin/manage/customers/participant/${selectedParticipant._id}/`,
      {
        withCredentials: true,
      }
    );
    if (deleteRequest.status === 200) {
      props.setSelectedParticipant("");
      props.setUpdateKey(currentKey + 1);
      props.setSubmitClicked(false);
      return props.fetchNewData();
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <FadeIn delay={250} duration={450}>
      <Row className='text-center mt-3'>
        <Col sm='12'>
          <h1>Participant Info</h1>
        </Col>
      </Row>
      <Row className='text-center align-items-center'>
        <Col sm='12' lg='8'>
          <div className='shadow mt-4 p-3 border'>
            <h3>{`${selectedParticipant.First_Name} ${selectedParticipant.Last_Name}`}</h3>
            <h5>Age</h5>
            <Moment format='Y [year], M [months]' durationFromNow ago>
              {selectedParticipant.Date_Of_Birth}
            </Moment>{" "}
            old
            <br />
            <span className='smallprint'>{selectedParticipant.Date_Of_Birth}</span>
            <hr />
            <h5>Emergency Contact 1</h5>
            <a href={`tel:${selectedParticipant.Emergency_Contact_1_Contact_Number}`}>
              {selectedParticipant.Emergency_Contact_1_Contact_Number}
            </a>
            <br />
            <span className='smallprint'>{selectedParticipant.Emergency_Contact_1_Name}</span>
            <hr />
            <h5>Emergency Contact 2</h5>
            <a href={`tel:${selectedParticipant.Emergency_Contact_2_Contact_Number}`}>
              {selectedParticipant.Emergency_Contact_2_Contact_Number}
            </a>
            <br />
            <span className='smallprint'>{selectedParticipant.Emergency_Contact_2_Name}</span>
            <hr />
            <h5>Address</h5>
            <span>{selectedParticipant.Address}</span>
            {selectedParticipant.Special_Requirements !== "" && (
              <div>
                <hr />
                <h5>Special Requirements</h5>
                <span className='smallprint'>{selectedParticipant.Special_Requirements}</span>
              </div>
            )}
          </div>
        </Col>
        {selectedParticipant.WaitingList.length > 0 ||
        selectedParticipant.Subscriptions.length > 0 ? (
          <Col sm='12' lg='4'>
            <div className='shadow mt-4 p-3 border'>
              <h4>Regular Classes</h4>
              <p className='smallprint'>The participant&apos;s regular classes will show here.</p>
              {selectedParticipant.Subscriptions.map((subscription) => (
                <Button
                  variant='success'
                  key={subscription._id}
                  className='w-100 mt-1 mb-1'
                  size="sm"
                  as={Link}
                  to={`/admin/classes/${subscription.ClassID}`}
                >
                  {`${subscription.ClassLessonType} (${subscription.ClassDay}) - ${subscription.StripeStatus} `}
                </Button>
              ))}
            </div>
            <div className='shadow mt-4 p-3 border'>
              <h4>Blocks</h4>
              <p className='smallprint'>The participant&apos;s active block bookings.</p>
              {selectedParticipant.BlockClasses.map((block) => (
                <Button
                  variant='info'
                  key={block._id}
                  className='w-100 mt-1 mb-1'
                  size="sm"
                  as={Link}
                  to={`/admin/blocks/${block._id}`}
                >
                  {block.LessonType}
                </Button>
              ))}
            </div>
            <div className='shadow mt-4 p-3 border'>
              <h4>Waiting</h4>
              <p className='smallprint'>The participant&apos;s waiting list entries will appear here.</p>
              {selectedParticipant.WaitingList.map((waiting) => (
                <Button
                  variant='warning'
                  key={waiting._id}
                  className='w-100 mt-1 mb-1'
                  size="sm"
                  as={Link}
                  to={`/admin/classes/${waiting.ClassID}`}
                >
                  {`${waiting.ClassLessonType} (${waiting.ClassDay}) - ${waiting.Status} `}
                </Button>
              ))}
            </div>
          </Col>
        ) : (
          <Col className='text-center' sm='12' lg='4'>
            <div className='shadow mt-4 p-3 border'>
              <h1>Delete Participant</h1>
              <p>This participant has no waiting lists or subscriptions so can be deleted.</p>
              <Button
                variant='primary'
                className='w-100 mt-2 mb-2'
                onClick={(e) => deleteParticipant(e)}
                disabled={props.submitClicked}
              >
                Delete
              </Button>
            </div>
          </Col>
        )}
      </Row>
      <Row className='text-center mt-3'>
        <Col sm='12'>
          <div className='shadow mt-4 p-3 border'>
            <h4>Event Log</h4>
            <p>The participant&apos;s transfers, class joins and other events will show here.</p>
            {selectedParticipant.historyLog !== undefined &&
              selectedParticipant.historyLog[0] !== undefined && (
                <div>
                  {selectedParticipant.historyLog.map((i) => (
                    <span key={i}>
                      <small>{i}</small>
                      <hr />
                    </span>
                  ))}
                </div>
              )}
          </div>
        </Col>
      </Row>
    </FadeIn>
  );
};

export default withRouter(CustomerView);
